import SimpleMinimizedMail from './SimpleMinimizedMail';

export default SimpleMinimizedMail;


// WEBPACK FOOTER //
// /src/components/mailThread/mail/simpleMinimizedMail/index.js